// extracted by mini-css-extract-plugin
module.exports = {"top-bar":"top-bar_top-bar__6RX5S","no-ads":"top-bar_no-ads__Tw5Ot"};